const getNameInitials = (fullName) => {
    if (!fullName) return;
    if (fullName.indexOf(" ") === -1) return fullName.charAt(0) + "" + fullName.charAt(1);
    const [fname, lname] = fullName.split(" ");
    return fname.charAt(0) + "" + lname.charAt(0);
};

const whitelistedFileHexes = (hex) => {
    if (!hex) return;
    const allowedHexes = [
        "89504E47",
        "89504E470D0A1A0A",
        "FFD8FFE0",
        "FFD8FFE1",
        "FFD8FFDB",
        "47494638",
        "3C3F786D",
        "00020",
        "00014",
        "4F726465",
        "68617368",
        "504B34",
        "504B0304",
        "504B0506",
        "FFFB",
        "494433",
        "D0CF11E0",
        "FFD8FFE2",
        "25504446",
        "d0cf11e0",
    ];
    return allowedHexes.includes(hex);
};

const random_color = () => {
    const round = Math.round,
        rand = Math.random,
        max = 254;
    const r = round(rand() * max),
        g = round(rand() * max),
        b = round(rand() * max),
        a = rand().toFixed(1);
    return {
        rgba: `rgba(${r},${g},${b},${a})`,
        rgb: `rgba(${r},${g},${b})`,
    };
};
const dateFormatter = (isoString, showTime = false) => {
  if (!isoString) return "";
let normalized = isoString.replace(/\.(\d{3})\d+(?=\+|Z)/, ".$1");

    const date = new Date(normalized);
  if (isNaN(date.getTime())) return "Invalid Date";

  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  const yyyy = date.getFullYear();

  if (!showTime) return `${mm}/${dd}/${yyyy}`;

  const hh = String(date.getHours()).padStart(2, "0");
  const min = String(date.getMinutes()).padStart(2, "0");
  const ss = String(date.getSeconds()).padStart(2, "0");

  // Final format: MM/DD/YYYY HH:MM:SS (ISO style)
  return `${mm}/${dd}/${yyyy} ${hh}:${min}:${ss}`;
};


const getChipStyle = (value) => {
    switch (value?.toLowerCase()) {
        case "active":
            return {
                "background": "#D0FFE2",
                "color": "#28BA62",
            };
        case "revoked":
            return {
                "background": "#FFEFBD",
                "color": "#E0AC08",
            };
        case "deleted":
            return {
                "background": "#FDEDEC",
                "color": "#C0392B",
            };
        default:
            return {
                "background": "#E5E8E8",
                "color": "#34495E",
            };
    }
};
export { getNameInitials, whitelistedFileHexes, random_color, getChipStyle, dateFormatter };

// ---------------------------------------------------------------------------
// Array utilities — migrated from src/mixins/global.js
// ---------------------------------------------------------------------------

/**
 * Returns a new array with duplicate primitive values removed.
 */
export function unique(list) {
  const result = [];
  list.forEach((e) => (result.indexOf(e) === -1 ? result.push(e) : 0));
  return result;
}

/**
 * Returns a new array with duplicate objects removed based on a key field.
 * @param {Array} list
 * @param {'id'|'vertex'|'currency_code'} varname - Field to compare uniqueness by
 */
export function uniqueObjectiveArray(list, varname) {
  const result = [];
  list.forEach((event) => {
    const exists = result.some((e) => {
      if (varname === 'id') return event.id === e.id;
      if (varname === 'vertex') return event.vertex === e.vertex;
      return event.currency_code === e.currency_code;
    });
    if (!exists) result.push(event);
  });
  return result;
}
